import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  classDetails: [
    {
      _id: "",
      sectionName: "",
      sectionNumber: "",
      instructorFirstName: "",
      instructorLastName: "",
      instructorEmails: [],
      sections: [],
    },
  ],
};

const slice = createSlice({
  name: "section",
  initialState,

  reducers: {
    setClassDetails: (state, action) => {
      state.classDetails = action.payload;
    },
    resetClasses: (state) => {
      state = initialState;
    },
  },
});

export const { setClassDetails, resetClasses } = slice.actions;
export default slice.reducer;
